/**
 * Ana sayfa kartları rapor sorgusu değildir; düzen hiçbir veri yetkisi taşımaz.
 * Kimlik listesi veritabanındaki `novemai_home_dashboard_layout_valid` ile aynı
 * tutulur; yeni kimlik o fonksiyonu yenileyen bir migration ister.
 */
export const HOME_WIDGET_IDS = [
  "pending_total", "approved_total", "employees_total", "rejected_total",
  "pending_requests", "leave_distribution", "quick_links",
  "approval_queue", "my_requests", "leave_balance", "my_tasks", "announcements",
  "next_payroll", "upcoming_holidays", "recent_activity",
] as const;
export type HomeWidgetId = (typeof HOME_WIDGET_IDS)[number];
export const HOME_WIDGET_SIZES = ["small", "medium", "large"] as const;
export type HomeWidgetSize = (typeof HOME_WIDGET_SIZES)[number];
export interface HomeWidgetLayout {
  readonly id: HomeWidgetId;
  readonly size: HomeWidgetSize;
  readonly hidden: boolean;
}
export const DEFAULT_HOME_LAYOUT: readonly HomeWidgetLayout[] = [
  { id: "pending_total", size: "small", hidden: false },
  { id: "approved_total", size: "small", hidden: false },
  { id: "employees_total", size: "small", hidden: false },
  { id: "rejected_total", size: "small", hidden: false },
  { id: "pending_requests", size: "medium", hidden: false },
  { id: "approval_queue", size: "medium", hidden: false },
  { id: "my_requests", size: "medium", hidden: false },
  { id: "leave_distribution", size: "medium", hidden: false },
  { id: "leave_balance", size: "medium", hidden: false },
  { id: "my_tasks", size: "medium", hidden: false },
  { id: "announcements", size: "medium", hidden: false },
  { id: "next_payroll", size: "medium", hidden: false },
  { id: "upcoming_holidays", size: "medium", hidden: false },
  { id: "recent_activity", size: "large", hidden: false },
  { id: "quick_links", size: "large", hidden: false },
];

/** Eski düzene sonradan gelen kartlar gizli eklenir; yayımdan sonra görünüm sıçramaz. */
export function reconcileHomeLayout(saved: readonly HomeWidgetLayout[] | null): readonly HomeWidgetLayout[] {
  if (saved === null) return DEFAULT_HOME_LAYOUT;
  const present = new Set(saved.map(widget => widget.id));
  return [...saved, ...DEFAULT_HOME_LAYOUT.filter(widget => !present.has(widget.id)).map(widget => ({ ...widget, hidden: true }))];
}
